import { useEffect } from 'react';
var triggeredFlags = new Set();
export function useSplitAmplitude(_a) {
    var isReady = _a.isReady, experimentName = _a.experimentName, treatment = _a.treatment;
    useEffect(function () {
        if (isReady &&
            typeof window !== 'undefined' &&
            window.dataLayer !== undefined &&
            !triggeredFlags.has(experimentName)) {
            triggeredFlags.add(experimentName);
            window.dataLayer.push({
                event: 'amp_exp_set',
                exp_name: experimentName,
                treatment_name: treatment
            });
        }
    }, [isReady]);
}
//# sourceMappingURL=useSplitAmplitude.js.map